export default "__VITE_ASSET__CkEODPI0__"